module.exports = __webpack_public_path__ + "img/ylands_comp_create_top_1920_FINAL_FIX.981550ae.png";